import { render, staticRenderFns } from "./AdditionalDocuments.vue?vue&type=template&id=39ff0005&"
import script from "./AdditionalDocuments.vue?vue&type=script&lang=js&"
export * from "./AdditionalDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports